'use client';

import { useEffect, useState } from 'react';
import { formatDateKST, timeAgo } from '#/lib/date';

/**
 * 상대 시간("3분 전")을 하이드레이션-안전하게 표시한다 (#274).
 * 서버 렌더와 첫 클라이언트 렌더는 입력만으로 결정되는 절대 날짜(KST)를 내고,
 * 마운트 후에야 현재 시각 기반 상대 시간으로 바꾼다. 렌더 중 Date.now() 를
 * 호출하면 SSR/하이드레이션 텍스트가 갈려 React #418 이 발생한다.
 */
export function TimeAgo({
  date,
  className
}: {
  date: string | Date;
  className?: string;
}) {
  const [relative, setRelative] = useState<string | null>(null);

  useEffect(() => {
    setRelative(timeAgo(date, Date.now()));
  }, [date]);

  return <span className={className}>{relative ?? formatDateKST(date)}</span>;
}
